export const googleFormConfig = {
    formAction: "https://docs.google.com/forms/u/0/d/e/1FAIpQLSe8Ri75psp8doT5_pwbhPromt9EV4dzst5lwkDv_2arBRTy0w/formResponse",
    entryIds: {
        name: "entry.232405728",
        email: "entry.337849913",
        phone: "entry.1192968343",
        message: "entry.416025743"
    }
};

export const isGoogleFormConfigured = () => {
    const { formAction, entryIds } = googleFormConfig;

    return Boolean(
        formAction &&
        entryIds.name &&
        entryIds.email &&
        entryIds.phone &&
        entryIds.message
    );
};